import { API_APPOINTMENT, API_IAM } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function getClinicsOfCurrentDoctor() {
  return {
    types: [
      ACTION_TYPES.MY_CLINIC_GET_REQUESTED,
      ACTION_TYPES.MY_CLINIC_GET_SUCCEED,
      ACTION_TYPES.MY_CLINIC_GET_FAILED,
    ],
    promise: client => client.get(`/v1.4/doctors/clinics`),
    options: {
      clientName: API_APPOINTMENT,
    },
  };
}

export function getClinicsOfDoctor(doctorId) {
  return {
    types: [
      ACTION_TYPES.CLINIC_GET_REQUESTED,
      ACTION_TYPES.CLINIC_GET_SUCCEED,
      ACTION_TYPES.CLINIC_GET_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/clinics`),
    options: {
      clientName: API_IAM,
    },
  };
}

export function getToClinicsOfDoctor(doctorId) {
  // use for referral memo
  return {
    types: [
      ACTION_TYPES.TO_CLINICS_GET_BY_DOCTOR_REQUESTED,
      ACTION_TYPES.TO_CLINICS_GET_BY_DOCTOR_SUCCEED,
      ACTION_TYPES.TO_CLINICS_GET_BY_DOCTOR_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/clinics`),
    options: {
      clientName: API_IAM,
    },
  };
}

export function getClinicDetail(clinicId) {
  return {
    types: [
      ACTION_TYPES.CLINIC_DETAIL_GET_REQUESTED,
      ACTION_TYPES.CLINIC_DETAIL_GET_SUCCEED,
      ACTION_TYPES.CLINIC_DETAIL_GET_FAILED,
    ],
    promise: client => client.get(`/clinics/${clinicId}`),
    options: {
      clientName: API_IAM,
    },
  };
}

export function setCurrentClinic(clinicId) {
  return {
    type: ACTION_TYPES.SET_CURRENT_CLINIC_SELECTION,
    clinicId,
  };
}
